import type { FC } from "react";

import { InteractionModeChip } from "components/materials/page/interaction-mode/InteractionModeChip";
import { InteractionModeListbox } from "components/materials/page/interaction-mode/InteractionModeListbox";
import { InteractionMode } from "components/server-types";
import { Tooltip } from "mds/components/Tooltip";
import { pageSelectors } from "store/selectors";
import { useObjectSelector } from "store/store-hooks";

export type ManageContentInteractionModeProps = {
  pageId: string;
  disabled: boolean;
  disabledTooltip?: string;
  onModeChange: (mode: InteractionMode) => void;
};

export const ManageContentInteractionMode: FC<ManageContentInteractionModeProps> = ({
  pageId,
  disabled,
  disabledTooltip,
  onModeChange,
}) => {
  const page = useObjectSelector((s) => pageSelectors.selectById(s, pageId), ["interaction_mode"]);
  if (page?.interaction_mode === InteractionMode.STATIC || disabled) {
    return (
      <Tooltip content={disabledTooltip}>
        <InteractionModeChip hasTooltip={!!disabledTooltip} pageId={pageId} disabled />
      </Tooltip>
    );
  }

  return <InteractionModeListbox pageId={pageId} onModeChange={onModeChange} />;
};

ManageContentInteractionMode.displayName = "ManageContentInteractionMode";
